import { CSSObject } from '@chakra-ui/react';

export const FlexPageWrapper: CSSObject = {
  px: '0',
  pb: '3',
  mt: '1',
  color: 'white',
  bg: 'transparent',
};
